import { createContext } from 'react'

import { CountriesContextProps } from './CountriesContext.types'

export const CountriesContext = createContext<CountriesContextProps | undefined>(undefined)
